<template>
<div v-bind:class="{'locked':token === null}">
	<ul class="title-nav">
		<li v-on:click="handleBack()">
			<div class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">assignment</i> ZONING ({{parcel.zoning.length}})</div>
		</li>
	</ul>

	<div v-if="token === null" v-on:click="routeLogin" class="lock-block">
		<div class="lock-icon-box">
			<i class="material-icons md-36">account_box</i>
		</div>
		<div class="lock-text">
			<h5 class="mb-0 text-white">Sign in to view zoning</h5>
			<h5 class="mb-0 font-weight-light text-light">Get details on parcel capabilities</h5>
		</div>
	</div>
	<!--h5 class="mb-2">
		ZONING 
		<small>({{parcel.zoning.length}})</small>
		<span class="updated-text">updated {{parcel.updated | ago}}</span>
		
	</h5-->
	<div v-if="parcel.zoning.length === 0" class="section-title text-center">
		No zoning info for this parcel
	</div>
	
	<div class="mb-3" v-for="(zone, index) in parcel.zoning">
		
		<div class="section">
			<div class="section-title">
				<span class="link" v-on:click="routeZoning(zone)">{{zone.designation}}</span>
			</div>
			<div class="section-body">

				<div class="category">
					<div class="category-title">DESCRIPTION</div>
					<div class="property-row">
						<div class="text-break property-locked">
							{{zone.description || 'No description available'}}
						</div>
					</div>
				</div>
				<div v-for="(regulation, regInd) in zone.regulations">
					<div v-if="regulation.lotSize.minArea !== null || regulation.lotSize.maxArea !== null ||
						regulation.lotSize.minWidth !== null || regulation.lotSize.minWidthCorner !== null || 
						regulation.lotSize.minFrontage !== null || regulation.lotSize.minDepth !== null" class="category">
						<div class="category-title">LOT SIZE</div>
						<div class="property-row" v-if="regulation.lotSize.minArea !== null">
							<label>Minimum area</label>
							<div class="property-value-right property-locked">
								{{regulation.lotSize.minArea | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.lotSize.maxArea !== null">
							<label>Maximum area</label>
							<div class="property-value-right property-locked">
								{{regulation.lotSize.maxArea | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.lotSize.minWidth !== null">
							<label>Minimum width</label>
							<div class="property-value-right property-locked">
								{{regulation.lotSize.minWidth | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.lotSize.minWidthCorner !== null">
							<label>Minimum width corner</label>
							<div class="property-value-right property-locked">
								{{regulation.lotSize.minWidthCorner | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.lotSize.minFrontage !== null">
							<label>Minimum frontage</label>
							<div class="property-value-right property-locked">
								{{regulation.lotSize.minFrontage | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.lotSize.minDepth !== null">
							<label>Minimum depth</label>
							<div class="property-value-right property-locked">
								{{regulation.lotSize.minDepth | integerLg}} ft
							</div>
						</div>
					</div>
					<div v-if="regulation.density.sfDu !== null" class="category">
						<div class="category-title">DENSITY</div>
						<div class="property-row">
							<label>SF/DU</label>
							<div class="property-value-right property-locked">
								{{regulation.density.sfDu | integerLg}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.density.sfDuNote !== null"> 
							<label>SF/DU note</label>
							<div class="property-value-right property-locked">
								{{regulation.density.sfDuNote}}
							</div>
						</div>
					</div>
					<div v-if="regulation.heightLimit.max !== null || regulation.heightLimit.aboveEnclosedParking !== null || regulation.heightLimit.roofFlat !== null || regulation.heightLimit.roofPitched !== null" class="category">
						<div class="category-title">HEIGHT LIMIT</div>
						<div class="property-row" v-if="regulation.heightLimit.max !== null">
							<label>Height maximum</label>
							<div class="property-value-right property-locked">
								{{regulation.heightLimit.max | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.heightLimit.aboveEnclosedParking !== null">
							<label>Above enclosed parking</label>
							<div class="property-value-right property-locked">
								{{regulation.heightLimit.aboveEnclosedParking | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.heightLimit.roofFlat !== null">
							<label>Roof flat limit</label>
							<div class="property-value-right property-locked">
								{{regulation.heightLimit.roofFlat | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.heightLimit.roofPitched !== null">
							<label>Roof pitched limit</label>
							<div class="property-value-right property-locked">
								{{regulation.heightLimit.roofPitched | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.heightLimit.note !== null">
							<label>Height note</label>
							<div class="property-value-right property-locked">
								{{regulation.heightLimit.note}} ft
							</div>
						</div>
					</div>
					<div v-if="regulation.far.base !== null || regulation.far.min !== null || 
						regulation.far.max !== null || regulation.far.residential !== null || 
						regulation.far.commercial !== null || regulation.far.mixed !== null" class="category">
						<div class="category-title">FLOOR TO AREA RATIO (FAR)</div>
						<div class="property-row" v-if="regulation.far.base !== null">
							<label>FAR base</label>
							<div class="property-value-right property-locked">
								{{regulation.far.base}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.far.min !== null">
							<label>FAR minimum</label>
							<div class="property-value-right property-locked">
								{{regulation.far.min}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.far.max !== null">
							<label>FAR maximum</label>
							<div class="property-value-right property-locked">
								{{regulation.far.max}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.far.residential !== null">
							<label>FAR residential</label>
							<div class="property-value-right property-locked">
								{{regulation.far.residential}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.far.commercial !== null">
							<label>FAR commercial</label>
							<div class="property-value-right property-locked">
								{{regulation.far.commercial}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.far.mixed !== null">
							<label>FAR mixed</label>
							<div class="property-value-right property-locked">
								{{regulation.far.mixed}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.far.note !== null">
							<label>FAR note</label>
							<div class="property-value-right property-locked">
								{{regulation.far.note}}
							</div>
						</div>
					</div>
					<div v-if="regulation.setbacks.frontMin !== null || regulation.setbacks.frontMax !== null || 
						regulation.setbacks.interiorSide !== null || regulation.setbacks.streetSide !== null || 
						regulation.setbacks.rear !== null || regulation.setbacks.rearAlley !== null ||
						regulation.setbacks.rearAlley !== null || regulation.setbacks.generalNote !== null" class="category">
						<div class="category-title">SETBACKS</div>
						<div class="property-row" v-if="regulation.setbacks.frontMin !== null">
							<label>Front minimum</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.frontMin | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.frontMinNote !== null">
							<label>Front minimum note</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.frontMinNote}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.frontMax !== null">
							<label>Front maximum</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.frontMax | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.frontMaxNote !== null">
							<label>Front maximum note</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.frontMaxNote}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.interiorSide !== null">
							<label>Interior side</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.interiorSide | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.interiorSideNote !== null">
							<label>Interior side note</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.interiorSideNote}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.streetSide !== null">
							<label>Street side</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.streetSide | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.streetSideNote !== null">
							<label>Street side note</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.streetSideNote}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.rear !== null">
							<label>Rear</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.rear | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.rearAlley !== null">
							<label>Rear</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.rearAlley | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.rearNote !== null">
							<label>Rear note</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.rearNote}}
							</div>
						</div>
						<div class="property-row" v-if="regulation.setbacks.generalNote !== null">
							<label>General note</label>
							<div class="property-value-right property-locked">
								{{regulation.setbacks.generalNote}}
							</div>
						</div>
					</div>
					<div v-if="regulation.lotCoverage.min !== null || regulation.lotCoverage.max !== null" class="category">
						<div class="category-title">LOT COVERAGE</div>
						<div class="property-row" v-if="regulation.lotCoverage.min !== null">
							<label>Lot coverage minimum</label>
							<div class="property-value-right property-locked">
								{{regulation.lotCoverage.min | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.lotCoverage.max !== null">
							<label>Lot coverage maximum</label>
							<div class="property-value-right property-locked">
								{{regulation.lotCoverage.max | integerLg}} ft
							</div>
						</div>
						<div class="property-row" v-if="regulation.lotCoverage.note !== null">
							<label>Lot coverage note</label>
							<div class="property-value-right property-locked">
								{{regulation.lotCoverage.note}}
							</div>
						</div>
					</div>
					<div v-if="zone.references" class="categorty">
						<div class="category-title">REFERENCES</div>
						<div class="property-row" v-for="(ref, idx) in zone.references">
							<label>{{ref.description}}</label>
							<div class="property-value-right">
								<a :href="ref.url" target="_blank">Link <i class="material-icons md-12">open_in_new</i></a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="over-action d-flex" v-if="token === null" v-on:click="routeLogin">
				<div class="over-action-box align-self-center text-white hover-dk">
					<div class="text-center">
						<i class="material-icons text-light md-36">account_box</i>
					</div>
					<div class="text-center">
						Sign in to view
					</div>
				</div>
			</div>
		</div>
	</div>
	
</div>

</template>

<script>
import {mapActions} from 'vuex';

export default {
	props: {
		addressId: Number,
		
		handleBack:{
			type:Function,
			required:true,
		},
		parcel:{
			type:Object,
			required:true,
		},
	},
	computed:{
		token: function(){
			return this.$store.state.agent.token;
		},
		deviceType: function(){
			return this.$store.state.device.type;
		}
	},
	created:function(){
		if (!this.parcel || !this.parcel.overlays){
			this.$data.overlaySources = [];
			return;
		}

		// collect overlays into sources
		let sourcesMap = {};
		this.parcel.overlays.map((overlay)=>{
			let index = overlay.sourceId+'_'+overlay.layerId;
			if (!sourcesMap[index]){
				sourcesMap[index] = {
					name:overlay.name,
					description:overlay.description,
					sourceId:overlay.sourceId,
					layerId:overlay.layerId,
					features:[]
				};
			}
			sourcesMap[index].features.push(overlay);
		});
		let sourcesAry = [];
		for (let i in sourcesMap){
			sourcesAry.push(sourcesMap[i]);
		}

		this.$data.overlaySources = sourcesAry;
	},
	data:function(){
		return {
			overlaySources:[],
			overlaysVisible:{}
		}
	},
	methods:{
		jurisdictionPermitURL: function(permitId){
			//	TODO: make this dynamic for all jurisdictions
			return 'https://opendsd.sandiego.gov/Web/Approvals/Details/'+permitId;
		},
		routeLogin: function(){
			this.$router.push({
				name: 'auth', 
				params:{}
			});
		},
		routeOverlay: function(overlay){
			let bbox = this.parcel.bounds.bbox;
			let centerX = bbox[0] + (bbox[2] - bbox[0])/2;
			let centerY = bbox[1] + (bbox[3] - bbox[1])/2;

			//	update our route which will fetch the community plan
			this.$router.push({
				name: 'overlay', 
				params:{
					id: overlay.id
				},
				query:{
					lat: centerX.toFixed(5),
					lng: centerY.toFixed(5)
				}
			});
		},
		routeZoning: function(zoning){
			let bbox = this.parcel.bounds.bbox;
			let centerX = bbox[0] + (bbox[2] - bbox[0])/2;
			let centerY = bbox[1] + (bbox[3] - bbox[1])/2;

			//	update our route which will fetch the community plan
			this.$router.push({
				name: 'zoning', 
				params:{
					id: zoning.id
				},
				query:{
					lat: centerX.toFixed(5),
					lng: centerY.toFixed(5)
				}
			});
		},
		routeBack:function(){
			this.$router.push({
				name:'parcels',
				params:{
					id:this.parcel.id
				},
				query:{
					addressId:this.addressId
				}
			});
		},
		overlayLayerToggle: function(overlay){
			const key = this.overlayKey(overlay);
			if (!this.overlaysVisible[key]){
				this.overlaysVisible = {...this.overlaysVisible, [key]:true};
				this.$store.dispatch('MAP_FEATURE_VISIBLE_ON',[{
					sourceLayer:'overlays',
					featureId: overlay.features[0].id,
					properties:{
						layerId: overlay.layerId,
						sourceId: overlay.sourceId
					}
				},{
					sourceLayer:'overlay_labels',
					properties:{
						layerId: overlay.layerId,
						sourceId: overlay.sourceId
					}
				}]);
				
			} else {
				this.overlaysVisible = {...this.overlaysVisible, [key]:false};
				this.$store.dispatch('MAP_FEATURE_VISIBLE_OFF',[{
					sourceLayer:'overlays',
					featureId: overlay.features[0].id,
					properties:{
						layerId: overlay.layerId,
						sourceId: overlay.sourceId
					}
				},{
					sourceLayer:'overlay_labels',
					properties:{
						layerId: overlay.layerId,
						sourceId: overlay.sourceId
					}
				}]);
			}
		},
		overlayKey: function(overlay){
			return overlay.sourceId+'-'+overlay.layerId;
		}		
	}
}

</script>

<style>
	.bg-gray{background-color:#FAFAFA;}
	.font-10{font-size:10px;}
	.censor-block{height:18px;width:100px;background-color:#455963;}
	.text-blur{color:transparent;text-shadow:0px 0px 10px #999;}
	.over-sign-in{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(55,71,79,0.2);}
	.over-sign-in-box{padding:12px 0;width:120px;margin:0 auto;
		text-align:center;color:#fff;}
	.section .feature{}
	.visible-icon{cursor:pointer;opacity:0.9;}
	.visible-icon:hover{opacity:1;}
	.visible-icon.active{color:#1A75D3;}
</style>


// WEBPACK FOOTER //
// src/components/parcel/parcel-zoning.vue